<script>
  import { onMount } from "svelte";
  import { filtered, anneePopUp } from "../store/DepensesStore";

  let selectedYear = 0;
  let promise;
  let tabTrier = [];
  /**
   * Calcul le total pour le tableau
   * @param arr
   */
  const sumTab = (arr) => {
    let tot = 0;
    for (let i = 0; i < arr.length; i++) {
      tot += parseFloat(arr[i].COP_MONT);
      //console.log(arr[i].COP_MONT);
    }
    return Math.round(tot);
  };

  /**
   * Creer un tableau d'année à partir de 2015 à aujourd hui
   * @returns
   */
  const tabYear = async () => {
    let currentYear = new Date().getFullYear();
    let tabTemp = [];
    for (let i = 2015; i <= currentYear; i++) {
      tabTemp.push(i);
    }
    return tabTemp;
  };

  // declanche la recherche si le magasin ppopup change
  $: anneePopUp.set(selectedYear);

  onMount(async () => {
    promise = await tabYear();
  });
</script>

<div class="container">
  <h4>Récap frais dépenses</h4>
  {#if $filtered}
    Année :
    {#await promise then}
      <select bind:value={selectedYear}>
        {#each promise as item}
          <option value={item}>{item}</option>
        {/each}
      </select>
    {/await}
    total = {sumTab($filtered)}

    <table width="100%" class="table table-success table-striped">
      <thead>
        <tr class="titre bg-info">
          <td>date</td>
          <td>libelle</td>
          <td>MT</td>
          <td>T</td>
        </tr>
      </thead>
      <tbody>
        {#each $filtered as element}
          <tr>
            <td>{element.COP_DATE}</td>
            <td>{element.COP_LIBELLE}</td>
            <td>{new Intl.NumberFormat("fr-FR").format(element.COP_MONT)}</td>
            <td>{element.COP_GARAGE}</td>
          </tr>
        {/each}
      </tbody>
    </table>
    <br />
  {/if}
</div>

<style>
  table {
    font-size: 0.65em;
  }
  .titre {
    font-weight: bold;
  }
</style>
